import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {BasePageComponent} from "../../base-page.component";
import {ConfirmationService} from "primeng/api";
import {JobPostService} from "../../services/domain/jobpost.service";
import {
  AnnunciFiltri,
  AnnunciInEvidenza,
  Annuncio,
  CommesseAnnunciPortals
} from "../../models/annunci.models";
import { SharedEnumModelKeyValue } from 'src/app/models/shared.models';
import {ComuniDto, Provincia, Regione} from 'src/app/models/comuni.models';
import { PlaceService } from 'src/app/services/domain/place.service';
import { AnagraficaUtenteLavoroDesideratoDto, CCNLSettore } from 'src/app/models/preferenze.models';
import { MansioniDto } from 'src/app/models/lavoro.models';
import { WorkService } from 'src/app/services/domain/work.service';
import { PreferencesService } from 'src/app/services/domain/preferences.service';
import {ActivatedRoute} from "@angular/router";

@Component({
  selector: 'app-annunci',
  templateUrl: './annunci.component.html',
  styleUrls: ['./annunci.component.css'],
  providers : [ConfirmationService, JobPostService, PlaceService, WorkService, PreferencesService]
})
export class AnnunciComponent extends BasePageComponent  implements OnInit {

  constructor(private confirmationService : ConfirmationService,
              private jobPostService : JobPostService,
              private placeService : PlaceService,
              private workService : WorkService,
              private preferencesService : PreferencesService,
              private route : ActivatedRoute ) {
    super();

  }
  public comuniList : ComuniDto[] = [];
  public comuneResidenzaSelezionato : ComuniDto = new ComuniDto();
  public LavoroDesiderato : AnagraficaUtenteLavoroDesideratoDto = new AnagraficaUtenteLavoroDesideratoDto();
  public taskList : MansioniDto[] = [];
  public TipoOrarioSelezionato : SharedEnumModelKeyValue = new SharedEnumModelKeyValue();
  public lstTipoOrari : SharedEnumModelKeyValue[] = [];
  public ricercaLuogo : string = "";
  public lstRegione : Regione[] = [];
  public RegioneSelezionata : Regione = new Regione();
  public lstProvincia : Provincia[] = [];
  public ProvinciaSelezionata : Provincia = new Provincia();
  public lstSettori : CCNLSettore[] = [];
  public SettoreSelezionato : CCNLSettore = new CCNLSettore();
  public lstTipoContratto : Annuncio[] = [];
  public TipoContrattoSelezionato : Annuncio = new Annuncio();
  public jobPostSelected : AnnunciInEvidenza = new AnnunciInEvidenza();
  public showDetailsDialog : boolean = false;
  public headerDetailsDialog : string = "";
  public filtriAnnunciObj : AnnunciFiltri = new AnnunciFiltri();
  public commessaAnnuncio : CommesseAnnunciPortals[] = [];
  public totalAnnunci : number = 0;
  public idAnnuncio : string = "";


  ngOnInit(): void
  {
    this.getRegione();
    this.getProvincia();
    this.idAnnuncio = this.route.snapshot.paramMap.get('code') || "";

    if(this.idAnnuncio != ""){
      this.showDetails(this.idAnnuncio, true);
    }
  }
  // public getMansioni(event : any){
  //   if(event == null)
  //     return;
  //   if(event.query.length < 1)
  //     return;
  //
  //   this.asyncCall(() => this.workService.getTaskAutocomplete(event.query), response => {
  //     this.taskList = response.Items || [];
  //   });
  // }
  public getSettori(event : any){

    this.asyncCall(()=> this.jobPostService.getSettoreAutoComplete(event.query), response => {
      this.lstSettori = response.Items || [];
    });
  }
  public getRegione(event? : any){
    if (this.ProvinciaSelezionata.IdProvincia !== 0 || this.comuneResidenzaSelezionato.IdComune !== 0) {
      this.lstRegione = this.lstRegione.filter(regione => regione.IdRegione === this.ProvinciaSelezionata.IdRegione ||
                                                                   regione.IdRegione === this.comuneResidenzaSelezionato.IdRegione
    );
      if(this.lstRegione.length == 1){
        this.RegioneSelezionata = this.lstRegione[0];
      }
    } else {
      this.asyncCall(() => this.jobPostService.getRegione(event ? event.query : ''), response => {
        this.lstRegione = response.Items || [];
      });
    }
  }
  public getProvincia(event? : any){
    if(this.RegioneSelezionata.IdRegione != 0 || this.comuneResidenzaSelezionato.IdComune != 0){
      if(this.RegioneSelezionata.IdRegione != 0){
        this.lstProvincia = this.lstProvincia.filter(provincia => provincia.IdRegione === this.RegioneSelezionata.IdRegione);
      }
      if(this.comuneResidenzaSelezionato.IdProvincia != 0){
        this.lstProvincia = this.lstProvincia.filter(provincia => provincia.IdProvincia === this.comuneResidenzaSelezionato.IdProvincia);
      }
      if(this.lstProvincia.length == 1){
        this.ProvinciaSelezionata = this.lstProvincia[0];
      }
    }
    else{
      this.asyncCall(()=> this.jobPostService.getProvincia(event ? event.query : ''), response => {
        this.lstProvincia = response.Items || [];
      });
    }
  }
  public getTipoContratto(event : any){
    this.asyncCall(()=> this.jobPostService.getTipoContratto(event.query), response => {
      this.lstTipoContratto = response.Items || [];
    });
  }
  public getComuniAutoComplete(event : any){
    if(event == null)
      return;
    if(event.query.length < 1)
      return;

    if(this.ProvinciaSelezionata.IdProvincia != 0 || this.RegioneSelezionata.IdRegione != 0){
      this.asyncCall(() => this.placeService.getPlaceAutocomplete(event.query, this.ProvinciaSelezionata.IdProvincia, this.RegioneSelezionata.IdRegione ), response =>{
        this.comuniList = response.Items || [];
      });
    }
    else{
      this.asyncCall(() => this.placeService.getPlaceAutocomplete(event.query), response => {
        this.comuniList = response.Items || [];
      });
    }
    if(this.comuniList.length == 1){
      this.comuneResidenzaSelezionato = this.comuniList[0];
    }
  }
  public getOrarioPreferenze(event : any){
    this.asyncCall(() => this.preferencesService.getOrarioPreferenze(event.query), response => {
      this.lstTipoOrari = response.Items || [];
    });
  }
  public clearFilter(){
    this.filtriAnnunciObj = new AnnunciFiltri();
    this.ricercaLuogo = "";
    this.comuneResidenzaSelezionato = new ComuniDto();
    this.LavoroDesiderato = new AnagraficaUtenteLavoroDesideratoDto();
    this.ProvinciaSelezionata = new Provincia();
    this.RegioneSelezionata = new Regione();
    this.SettoreSelezionato = new CCNLSettore();
    this.TipoContrattoSelezionato = new Annuncio();
    this.TipoOrarioSelezionato = new SharedEnumModelKeyValue();
    this.getAnnunciFiltrati(null);
  }
  public getAnnunciFiltrati(event : any){
    if(event != null){
      this.filtriAnnunciObj.Offset = event.first;
      this.filtriAnnunciObj.Count = event.rows;
      //this.mdlGetListSelectionRequest.direction = event.sortOrder;

      /*switch(event.sortField){
        case("insertDate"):
          this.mdlGetListSelectionRequest.orderType = 0;
          break;
        case("company"):
          this.mdlGetListSelectionRequest.orderType = 1;
          break;
        case("task"):
          this.mdlGetListSelectionRequest.orderType = 2;
          break;
        case("descriptionState"):
          this.mdlGetListSelectionRequest.orderType = 3;
          break;
        case("candidateNumber"):
          this.mdlGetListSelectionRequest.orderType = 4;
          break;
        case("ac"):
          this.mdlGetListSelectionRequest.orderType = 5;
          break;
        case("cs"):
          this.mdlGetListSelectionRequest.orderType = 6;
          break;
        case("expirationDate"):
          this.mdlGetListSelectionRequest.orderType = 7;
          break;
        case("publicationDate"):
          this.mdlGetListSelectionRequest.orderType = 8;
          break;
        case("registeredJobPost"):
          this.mdlGetListSelectionRequest.orderType = 9;
          break;
        default:
          break;
      }*/
    }else{
      this.filtriAnnunciObj.Offset = 0;
      this.filtriAnnunciObj.Count = 10;
    }


    if(this.comuneResidenzaSelezionato.IdComune != 0)
      this.filtriAnnunciObj.IdComune = this.comuneResidenzaSelezionato.IdComune;
    if(this.LavoroDesiderato.IdMansione != 0)
      this.filtriAnnunciObj.IdMansione += this.LavoroDesiderato.IdMansione;
    if(this.ProvinciaSelezionata.IdProvincia != 0)
      this.filtriAnnunciObj.IdProvincia = this.ProvinciaSelezionata.IdProvincia;
    if(this.RegioneSelezionata.IdRegione != 0)
      this.filtriAnnunciObj.IdRegione = this.RegioneSelezionata.IdRegione;
    if(this.SettoreSelezionato.IdCCNLSettore != 0)
      this.filtriAnnunciObj.IdCCNLSettore = this.SettoreSelezionato.IdCCNLSettore;
    if(this.TipoContrattoSelezionato.TipoContrattoFiltro != ""){
      this.filtriAnnunciObj.TipoContratto = this.TipoContrattoSelezionato.TipoContrattoFiltro;
    }

    if(this.TipoOrarioSelezionato.Key != 0)
      this.filtriAnnunciObj.TipoOrario = this.TipoOrarioSelezionato.Key;

    this.asyncCall(() => this.jobPostService.getAnnunciFiltrati(this.filtriAnnunciObj), response => {
      this.commessaAnnuncio = response.Item?.ListaAnnunci || [];
      this.totalAnnunci = response.Item?.TotaleRecordAnnunci ?? 0;
    });
  }
  public onhideModal(){
    this.jobPostSelected = new AnnunciInEvidenza();
  }
  public closeModal(closeModal : boolean){
    this.showDetailsDialog = closeModal;
  }
  public showDetails(idAnnuncio: number | string, evidence : boolean){
    this.headerDetailsDialog = 'Dettaglio annuncio';
    this.showDetailsDialog = true;
    if(typeof idAnnuncio == 'string'){
      this.jobPostSelected.IdCommessaAnnuncioEnc = idAnnuncio;
    }
    else{
      this.jobPostSelected.IdCommessaAnnuncio = idAnnuncio
    }
  }

}

